module.exports = __webpack_public_path__ + "img/db.97997cdf.jpg";